import GradientText from 'components/GradientText';
import background from 'images/team-info-card.svg';

const TeamInfoCard = ({ number, text, icon }) => (
    <div className="team-info-card">
        <div className="team-info-card-inner">
            <img className="team-info-card__img" src={background} alt="" />
            <div className="team-info-card__content">
                {icon}
                <div>
                    <GradientText textColor="white">
                        <em>{number}</em>
                    </GradientText>
                    <div className="body1 opacity-70">{text}</div>
                </div>
            </div>
        </div>
    </div>
);

export default TeamInfoCard;
